import { useState } from "react";
import { useLocation } from "react-router-dom";
import { rememberCampaignAttribution } from "../utils/campaignAttributionUtils";

// Captures utm_* / gclid params from the URL on entry to a quote flow and
// returns the serialised `campaign` value to send on quote submissions
// (null when there are none). See campaignAttributionUtils.js.
export default function useCampaignAttribution() {
  const location = useLocation();
  const [campaign] = useState(() => rememberCampaignAttribution(location));
  return campaign;
}
